import { keepPreviousData } from '@tanstack/react-query';

import { EntityPromotionsResponse, PromotionFeatures } from '@playq/octopus-common';
import { GenericFailure } from '@playq/services-shared';

import { IBasePromotionService } from '/api/hooks/promotions/types';
import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';

const queryPromotionsKeys: unknown[] = ['promotions', 'service', 'query'];
export const useQueryPromotions = <ID>(
  id: ID | undefined,
  features: PromotionFeatures[],
  queryPromotions?: IBasePromotionService<ID>['queryPromotions'],
  options?: IUseQueryOptionsExtended<EntityPromotionsResponse | undefined, GenericFailure | Error>
) =>
  useEitherQuery(
    queryPromotionsKeys.concat(id, features),
    () => {
      if (id !== undefined) {
        return queryPromotions?.(id, features);
      }
    },
    {
      enabled: id !== undefined && !!queryPromotions,
      placeholderData: keepPreviousData,
      ...options,
    }
  );
